export default __webpack_public_path__ + "static/media/3169.c09ab56a.svg";